import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ProgressBarComponent implements OnInit {
  @Input() progress: number = 0;
  @Input() title: string = '';
  @Input() subtitle: string = '';

  private radius: number = 180;
  private circumference: number = 2 * Math.PI * this.radius;
  protected strokeOffset: number = .25 * this.circumference;

  protected get strokeDasharray(): string {
    const current = this.circumference * this.progress / 100

    return `${current} ${this.circumference - current}`
  }

  constructor() { }

  ngOnInit(): void { }


}
